import React from 'react';
import PropTypes from 'prop-types';
import css from './CwCheckBox.scss';
import cx from 'classnames';

class CwCheckBox extends React.Component {

  handleClick = () => {
    if (this.props.disabled || !this.props.onChange) {
      return;
    }
    this.props.onChange(!this.props.value);
  };

  handleKeyPress = (event) => {
    if (this.props.disabled || !this.props.onChange || event.which !== 32) {
      return;
    }
    this.props.onChange(!this.props.value);
  };

  componentDidMount() {
    if (this.props.autoFocus) {
      this.wrap.focus();
    }
  }

  componentDidUpdate() {
    if (this.props.onComponentDidUpdate) {
      this.props.onComponentDidUpdate(this.props.value);
    }
  }

  render() {

    const { disabled, value, invalid } = this.props;

    const controlClass = cx({
      [css.controlInvalid]: invalid && !disabled,
      [css.controlDisabled]: disabled,
      [css.control]: !disabled,
    });

    const checkboxClass = cx({
      [css.checkboxCheckedDisabled]: disabled && value,
      [css.checkboxDisabled]: disabled && !value,
      [css.checkboxChecked]: !disabled && value,
      [css.checkbox]: !disabled && !value,
      [css.checkboxCheckedInvalid]: !disabled && invalid && value,
      [css.checkboxInvalid]: !disabled && invalid && !value,
    });

    return (
      <div
        data-cwid={this.props.cwId}
        className={cx(css.wrap, this.props.className)}
        disabled={this.props.disabled}
        tabIndex={this.props.disabled ? -1 : this.props.tabIndex}
        readOnly={this.props.readOnly}
        ref={(input) => this.wrap = input}
        onKeyPress={this.handleKeyPress}
        onFocus={this.props.onFocus}
        onBlur={this.props.onBlur}
        onClick={this.handleClick}
        style={this.props.style}
      >
        <div id={this.props.id} className={controlClass}>
          <div id={this.props.id} className={checkboxClass} />
          {this.props.text ?
            <label id={this.props.id}>{this.props.text}
            </label> : null}
        </div>
      </div>
    );
  };
}

CwCheckBox.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: PropTypes.string,
  /**
   * Text next to checkbox
   */
  text: PropTypes.string,
  /**
   * Callback function when checkbox value is changed
   */
  onChange: PropTypes.func,
  /**
   * Used to check a checkbox
   */
  value: PropTypes.bool,
  /**
   * Can be used to disable checkbox
   */
  disabled: PropTypes.bool,
  /**
   * Unique id to be passed to event handlers
   */
  id: PropTypes.string,
  /**
   * Used to control tab order
   */
  tabIndex: PropTypes.number,
  /**
   * Used to control if checkbox is autofocused when the page loads
   */
  autoFocus: PropTypes.bool,
  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: PropTypes.func,
  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: PropTypes.func,
  /**
   * Used to display invalid state
   */
  invalid: PropTypes.bool,
  /**
   * Callback function that is fired when the component is updated
   */
  onComponentDidUpdate: PropTypes.func,
  /**
   * Override the styles of the root element
   */
  style: PropTypes.object,
  /**
   * The css class name to be appended to default classname
   */
  className: PropTypes.string,
};

CwCheckBox.defaultProps = {
  tabIndex: 0,
};

export default CwCheckBox;


// WEBPACK FOOTER //
// ./src/components/cwcheckbox/CwCheckBox.jsx